import React, { Component } from "react";
import Back from "../images/back.svg";
import NewPic from "../images/newpic.svg";
import Tick from "../images/tick.svg";
import Cancel from "../images/cancel.svg";
import Next from "../images/next.svg";
import CustomButton from "../components/CustomButton";
import { Form } from "react-bootstrap";
import axios from "axios";
import { ClapSpinner } from "react-spinners-kit";
import { toast } from "react-toastify";
import Loading from "../components/Loading";
import LangButton from "../components/LangButton";
import LangItem from "../components/LangItem";
import { Modal } from "react-bootstrap";
import Profile from "./Profile";
import Logout from "../images/logout.svg";
import Profilee from "../images/profile.svg";
import { word } from "../words.js";
import Tooltip from "@mui/material/Tooltip";
import {
  BaseUrl,
  Authorization,
  BaseUrlAssets,
  isUser,
  LogoutFunction,
} from "../static.js";

export default class CreateNewRestaurant extends Component {
  constructor(props) {
    super(props);
    this.state = {
      resTypeErrorText: "",
      resNameErrorText: "",
      emailErrorText: "",
      phoneNumErrorText: "",
      addressErrorText: "",
      descriptionErrorText: "",
      priceUnitErrorText: "",
      resNameValue: "",
      emailValue: "",
      phoneNumValue: "",
      addressValue: "",
      priceUnitValue: "",
      descriptionValue: "",
      buttonDisabled: false,
      actionError: "",
      uploadButtonDisable: false,
      uploadButtonDisableHeader: false,
      logoUrl: null,
      headerUrl: null,
      logoFileName: "",
      headerFileName: "",
      businessType: [],
      selectedBusinessType: null,
      serverResponse: false,
      businessTypeValue: "",
      doneLoading: false,
      menuLoading: false,
      subTitle: "اطلاعات رستوران خود را کامل کنید",
      pageLoading: true,
      currentID: "",
      ModalShow: false,
      userLangList: [],
      userLangListMain: [],
      // langList:[{title:'English',id:1},{title:'فارسی',id:2,selected:true},{title:'العربیه',id:3},{title:'Germany',id:4}],
      langList: [],
      langListMain: [],
      selectedLangId: 0,
      rtlClass: "",
      currentLang: "fa",
      modalContent: "language",
      lockModal: true,
      selectedLangIndex: 0,
      businessInfo: [],
      priceUnitList: [],
    };
    this.textHandleChange = this.textHandleChange.bind(this);
    this.phoneHandleChange = this.phoneHandleChange.bind(this);
    this.inputFile = React.createRef();
    this.inputFileHeader = React.createRef();
    this.uploadLogo = this.uploadLogo.bind(this);
    this.uploadHeader = this.uploadHeader.bind(this);
    this.getBusinessInfo = this.getBusinessInfo.bind(this);
    this.checkReq = this.checkReq.bind(this);
    this.validateEmail = this.validateEmail.bind(this);
    this.getLanguageList = this.getLanguageList.bind(this);
    this.getUserLanguageList = this.getUserLanguageList.bind(this);
    this.saveBusiness = this.saveBusiness.bind(this);
    this.getPriceUnit = this.getPriceUnit.bind(this);
  }

  componentDidMount() {
    if (this.props.isEdit) {
      this.setState({ lockModal: true });
    } else {
      this.setState({ lockModal: "static", ModalShow: true });
    }
    let data = {
      languageId: 1,
    };

    data = Object.assign(data, Authorization());

    fetch(BaseUrl + "getBusinessType", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(data),
    })
      .then((res) => res.json())
      .then((result) => {
        console.log("getBusinessType:", result.result);
        if (result.status === 200) {
          this.setState(
            {
              businessType: result.result,
              businessTypeValue: result.result[0].title,
            },
            () => {
              this.getPriceUnit();
            }
          );
        } else if (result.status === 401) {
          LogoutFunction();
        } else {
          this.props.history.push("/Restaurants");
        }
      })
      .catch((err) => {
        console.log(err);
      });
  }

  getPriceUnit() {
    let data = {};

    data = Object.assign(data, Authorization());

    fetch(BaseUrl + "getPriceUnit", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(data),
    })
      .then((res) => res.json())
      .then((result) => {
        console.log("getPriceUnit:", result.result);
        if (result.status === 200) {
          this.setState({ priceUnitList: result.result }, () => {
            this.getLanguageList();
          });
        } else if (result.status === 401) {
          LogoutFunction();
        }
      })
      .catch((err) => {
        console.log(err);
      });
  }

  getLanguageList() {
    let data = {
      countryVersion: "iran",
    };

    data = Object.assign(data, Authorization());

    fetch(BaseUrl + "getLanguageList", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(data),
    })
      .then((res) => res.json())
      .then((result) => {
        console.log("getLanguageList", result);
        if (result.status === 200) {
          this.setState(
            { langList: result.result, langListMain: result.result },
            () => {
              if (this.props.isEdit) {
                this.getBusinessInfo();
              } else {
                let unit = "";
                this.state.priceUnitList.forEach((element) => {
                  if (element.ltrTitle === "IRR") {
                    if (element.rtlTitle !== element.ltrTitle) {
                      unit = element.rtlTitle + "(" + element.ltrTitle + ")";
                    } else {
                      unit = element.rtlTitle;
                    }
                  }
                });

                this.setState({ pageLoading: false, priceUnitValue: unit });
              }
            }
          );
        } else if (result.status === 401) {
          LogoutFunction();
        }
      })
      .catch((err) => {
        console.log(err);
      });
  }

  getBusinessInfo() {
    let data = {
      businessCode: this.props.match.params.id,
    };

    data = Object.assign(data, Authorization());

    fetch(BaseUrl + "findBusinessWithCode", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(data),
    })
      .then((res) => res.json())
      .then((result) => {
        if (result.status === 200) {
          let type = "";
          this.state.businessType.forEach((element) => {
            if (element.id === result.result[0].businessType)
              type = element.title;
          });

          let unit = "";
          this.state.priceUnitList.forEach((element) => {
            if (element.id === result.result[0].priceUnit) {
              if (element.rtlTitle !== element.ltrTitle) {
                unit = element.rtlTitle + "(" + element.ltrTitle + ")";
              } else {
                unit = element.rtlTitle;
              }
            }
          });

          this.setState(
            {
              businessInfo: result,
              pageLoading: false,
              currentID: result.result[0].id,
              priceUnitValue: unit,
              businessTypeValue: type,
              resNameValue: result.result[0].name,
              subTitle: result.result[0].descr,
              emailValue: result.result[0].email,
              phoneNumValue: result.result[0].phoneNumber,
              addressValue: result.result[0].address,
              descriptionValue: result.result[0].descr,
            },
            () => {
              if (result.result[0].headerPic !== "") {
                if (!result.result[0].headerPic.startsWith("tempPic")) {
                  this.setState({
                    headerUrl: BaseUrlAssets + result.result[0].headerPic,
                    headerFileName: result.result[0].headerPic,
                  });
                }
              }

              if (result.result[0].logo !== "") {
                this.setState({
                  logoUrl: BaseUrlAssets + result.result[0].logo,
                  logoFileName: result.result[0].logo,
                });
              }
            }
          );
          this.getUserLanguageList(result.result[0].id);
        } else if (result.status === 401) {
          LogoutFunction();
        } else {
          this.props.history.push("/Restaurants");
        }
      })
      .catch((err) => {
        console.log(err);
      });
  }

  getUserLanguageList(id) {
    let data = {
      businessId: id,
    };

    data = Object.assign(data, Authorization());

    fetch(BaseUrl + "getBusinessLanguages", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(data),
    })
      .then((res) => res.json())
      .then((result) => {
        console.log("getLanguageList", result);
        if (result.status === 200) {
          console.log("getBusinessLanguages", result.result);
          // let userlangs=[];
          // result.result.forEach(element => {
          //     this.state.langList.forEach(element1 => {
          //         if (element.languageId===element1.id){
          //             if (element.defaultLanguage) element1.default=true;
          //             userlangs.push(element1);
          //         }
          //     });
          // });

          let langs = JSON.parse(JSON.stringify(this.state.langList));
          langs.forEach((element) => {
            result.result.forEach((element1) => {
              if (element.id === element1.languageId) {
                element.selected = true;
                if (element1.defaultLanguage) element.default = true;

                this.state.businessInfo.info.forEach((element2) => {
                  if (element2.languageId === element.id) {
                    element.name = element2.name;
                    element.descr = element2.descr;
                    element.address = element2.address;
                    element.priceUnit = element2.priceUnit;
                  }
                });
              }
            });
          });

          let selected = [];
          langs.forEach((element) => {
            if (element.selected) {
              selected.push(element);
            }
          });

          this.setState(
            {
              userLangList: selected,
              userLangListMain: selected,
              langList: langs,
            },
            () => {
              if (this.state.userLangList.length > 0) {
                this.setState({
                  selectedLangId: this.state.userLangList[0].id,
                  selectedLangIndex: 0,
                  currentLang: this.state.userLangList[0].tag,
                });
              }

              if (result.result[0].direction.toLowerCase() === "rtl") {
                this.setState({ rtlClass: " rtlStyle" });
              } else {
                this.setState({ rtlClass: " ltrStyle" });
              }

              this.setState({ pageLoading: false });
              // this.getBusinessInfo()
            }
          );
        } else if (result.status === 401) {
          LogoutFunction();
        }
      })
      .catch((err) => {
        console.log(err);
      });
  }

  uploadLogo(event) {
    if (
      event.target.files[0] !== undefined &&
      (event.target.files[0].type === "image/jpg" ||
        event.target.files[0].type === "image/png" ||
        event.target.files[0].type === "image/jpeg")
    ) {
      const data = new FormData();
      data.append("file", event.target.files[0]);
      data.append("type", "logo");
      this.setState({ uploadButtonDisable: true });
      axios.post(BaseUrl + "uploadfile", data).then((res) => {
        console.log(res);
        if (res.data.status === 200) {
          this.setState({
            logoUrl: BaseUrlAssets + res.data.data.fileName,
            logoFileName: res.data.data.fileName,
          });
          toast.success("بارگذاری لوگو با موفقیت انجام شد", {
            position: toast.POSITION.BOTTOM_RIGHT,
            hideProgressBar: true,
            autoClose: 6000,
            toastClassName: "toast",
          });
        } else {
          toast.error(res.data.message, {
            position: toast.POSITION.BOTTOM_RIGHT,
            hideProgressBar: true,
            autoClose: 6000,
            toastClassName: "toast",
          });
        }
        this.setState({ uploadButtonDisable: false });
      });
    }
  }

  uploadHeader(event) {
    if (
      event.target.files[0] !== undefined &&
      (event.target.files[0].type === "image/jpg" ||
        event.target.files[0].type === "image/png" ||
        event.target.files[0].type === "image/jpeg")
    ) {
      const data = new FormData();
      data.append("file", event.target.files[0]);
      data.append("type", "banner");
      this.setState({ uploadButtonDisableHeader: true });
      axios.post(BaseUrl + "uploadfile", data).then((res) => {
        console.log(res);
        if (res.data.status === 200) {
          this.setState({
            headerUrl: BaseUrlAssets + res.data.data.fileName,
            headerFileName: res.data.data.fileName,
          });
          toast.success("بارگذاری بنر با موفقیت انجام شد", {
            position: toast.POSITION.BOTTOM_RIGHT,
            hideProgressBar: true,
            autoClose: 6000,
            toastClassName: "toast",
          });
        } else {
          toast.error(res.data.message, {
            position: toast.POSITION.BOTTOM_RIGHT,
            hideProgressBar: true,
            autoClose: 6000,
            toastClassName: "toast",
          });
        }
        this.setState({ uploadButtonDisableHeader: false });
      });
    }
  }

  onBack() {
    this.props.history.push('/Restaurants')
  }

  textHandleChange(e) {
    this.setState({ [e.target.name]: e.target.value });
  }

  phoneHandleChange(event) {
    let telephone = event.target.value;
    if (!Number(telephone) && Number(telephone) !== 0 && telephone !== "")
      return;
    this.setState({ phoneNumValue: event.target.value });
  }

  importLogo() {
    this.inputFile.current.click();
  }

  importHeader() {
    this.inputFileHeader.current.click();
  }

  cancelClick() {
    this.onBack()
  }

  validateEmail(email) {
    const re =
      /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
    return re.test(String(email).toLowerCase());
  }

  checkReq() {
    let emptyfound = false;
    if (this.state.priceUnitValue === "") {
      this.setState({ priceUnitErrorText: "واحد پولی وارد نشده است" });
      emptyfound = true;
    } else {
      this.setState({ priceUnitErrorText: "" });
    }

    let found = false;
    let errId = "";
    let currentIndex = "";
    let i = 0;
    this.state.userLangList.forEach((element) => {
      if (
        element.name === undefined ||
        element.name === null ||
        element.name === ""
      ) {
        if (errId === "") errId = element.id;
        if (currentIndex === "") currentIndex = i;

        emptyfound = true;
        found = true;
      }
      i++;
    });

    if (found) {
      this.setState({ resNameErrorText: "نام رستوران را پر کنید" });
      this.setState({ selectedLangId: errId, selectedLangIndex: currentIndex });
    } else {
      this.setState({ resNameErrorText: "" });
    }

    // if (this.state.resNameValue===''){
    //     this.setState({resNameErrorText:'نام رستوران را پر کنید'})
    //     emptyfound=true;
    // }else{
    //     this.setState({resNameErrorText:''})
    // }

    if (this.state.emailValue !== "") {
      if (!this.validateEmail(this.state.emailValue)) {
        this.setState({ emailErrorText: "پست الکترونیک وارد شده معتبر نیست" });
        emptyfound = true;
      } else {
        this.setState({ emailErrorText: "" });
      }
    } else {
      this.setState({ emailErrorText: "" });
    }

    if (emptyfound) return false;
    else return true;
  }

  doneClick() {
    this.saveBusiness(true);
  }

  saveBusiness(done) {
    if (!this.checkReq()) return;

    let typeId = "";
    this.state.businessType.forEach((element) => {
      if (element.title === this.state.businessTypeValue) typeId = element.id;
    });

    let userlangs = JSON.parse(JSON.stringify(this.state.userLangList));
    let defaultId;

    let languages = [];
    userlangs.forEach((element) => {
      languages.push(element.id);
    });

    userlangs.forEach((element) => {
      element.languageId = element.id;
      if (element.name === undefined) element.name = "";
      if (element.address === undefined) element.address = "";
      if (element.descr === undefined) element.descr = "";
      if (element.default) defaultId = element.id;
      delete element.direction;
      delete element.tag;
      delete element.flag;
      delete element.id;
      delete element.title;
      delete element.selected;
      delete element.default;
    });

    let unitId = null;
    this.state.priceUnitList.forEach((element) => {
      if (
        this.state.priceUnitValue === element.rtlTitle ||
        this.state.priceUnitValue ===
          element.rtlTitle + "(" + element.ltrTitle + ")"
      ) {
        unitId = element.id;
      }
    });

    let data = {
      businessType: Number(typeId),
      priceUnit: unitId,
      info: userlangs,
      email: this.state.emailValue,
      phoneNumber: this.state.phoneNumValue,
      logo: this.state.logoFileName,
      headerPic: this.state.headerFileName,
      defaultLanguage: defaultId,
      languages: languages,
    };

    let api = "createBusiness";
    if (this.props.isEdit) {
      api = "editBusiness";
      data = {
        businessType: Number(typeId),
        priceUnit: unitId,
        info: userlangs,
        email: this.state.emailValue,
        phoneNumber: this.state.phoneNumValue,
        logo: this.state.logoFileName,
        headerPic: this.state.headerFileName,
        id: this.state.currentID,
      };
    }

    data = Object.assign(data, Authorization());

    console.log(data);

    this.setState({ buttonDisabled: true, doneLoading: true });

    fetch(BaseUrl + "" + api, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(data),
    })
      .then((res) => res.json())
      .then((result) => {
        console.log(result);

        if (result.status === 200 || result.status === 201) {
          if (done) {
            this.onBack();
          } else {
            if (result.code === undefined) {
              this.props.onCreateNewRestaurantNext(this.props.match.params.id);
            } else {
              this.props.onCreateNewRestaurantNext(result.code);
            }
          }
        } else if (result.status === 401) {
          LogoutFunction();
        } else {
          toast.error(result.message, {
            position: toast.POSITION.BOTTOM_RIGHT,
            hideProgressBar: true,
            autoClose: 6000,
            toastClassName: "toast",
          });
          this.setState({ buttonDisabled: false, doneLoading: false });
        }
      })
      .catch((err) => {
        this.setState({ buttonDisabled: false, doneLoading: false });
        console.log(err);
      });
  }

  menuClick() {
    this.saveBusiness(false);
  }

  businessTypeHandleChange(e) {
    this.setState({ businessTypeValue: e.target.value });
  }

  priceUnitHandleChange(e) {
    this.setState({ priceUnitValue: e.target.value });
  }

  hideModal() {
    if (this.state.modalContent === "language") {
      if (this.state.userLangList.length < 1) {
        toast.error("حداقل یک زبان باید انتخاب شود", {
          position: toast.POSITION.BOTTOM_RIGHT,
          hideProgressBar: true,
          autoClose: 6000,
          toastClassName: "toast",
        });
        return;
      }
    }

    this.setState({ ModalShow: false, modalContent: "" });
  }

  onLogout() {
    LogoutFunction();
  }

  onProfile() {
    this.setState({ ModalShow: true, modalContent: "profile" });
  }

  selectLangClick(id) {
    let i = 0;
    let currentIndex = 0;
    this.state.userLangList.forEach((element) => {
      if (id === element.id) currentIndex = i;
      i++;
    });
    this.setState(
      { selectedLangId: id, selectedLangIndex: currentIndex },
      () => {
        this.state.userLangList.forEach((element) => {
          if (element.id === id) {
            this.setState({ currentLang: element.tag });
            if (element.direction.toLowerCase() === "rtl") {
              this.setState({ rtlClass: " rtlStyle" });
            } else {
              this.setState({ rtlClass: " ltrStyle" });
            }
          }
        });
      }
    );
  }

  saveLanguage() {
    if (!this.props.isEdit) {
      let selected = [];
      this.state.langList.forEach((element) => {
        if (element.selected) {
          selected.push(element);
        }
      });

      if (selected.length < 1) {
        toast.error("حداقل یک زبان باید انتخاب شود", {
          position: toast.POSITION.BOTTOM_RIGHT,
          hideProgressBar: true,
          autoClose: 6000,
          toastClassName: "toast",
        });
        return;
      }

      this.setState(
        {
          userLangList: selected,
          lockModal: true,
          ModalShow: false,
          modalContent: "",
          selectedLangId: selected[0].id,
          selectedLangIndex: 0,
          currentLang: selected[0].tag,
        },
        () => {
          if (selected[0].direction.toLowerCase() === "rtl") {
            this.setState({ rtlClass: " rtlStyle" });
          } else {
            this.setState({ rtlClass: " ltrStyle" });
          }
        }
      );
    } else {
      let defaultid;
      this.state.langList.forEach((element) => {
        if (element.default) defaultid = element.id;
      });

      let selected = [];
      this.state.langList.forEach((element) => {
        if (element.selected) {
          selected.push(element);
        }
      });

      let addlist = [];
      let removelist = [];
      this.state.userLangListMain.forEach((element) => {
        let found = false;
        this.state.langList.forEach((element1) => {
          if (element.id === element1.id && element1.selected) {
            found = true;
          }
        });

        if (!found) {
          removelist.push(element.id);
        }
      });

      this.state.langList.forEach((element) => {
        if (element.selected) {
          let found = false;
          this.state.userLangListMain.forEach((element1) => {
            if (element.id === element1.id) {
              found = true;
            }
          });

          if (!found) {
            addlist.push(element.id);
          }
        }
      });

      let data = {
        businessId: this.state.currentID,
        defaultLanguage: defaultid,
        addList: addlist,
        removeList: removelist,
      };

      data = Object.assign(data, Authorization());

      console.log("edit Langsss ", data);
      // return;
      fetch(BaseUrl + "editBusinessLanguages", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(data),
      })
        .then((res) => res.json())
        .then((result) => {
          console.log("editLanguage:", result);
          if (result.status === 200) {
            this.setState(
              {
                userLangList: selected,
                lockModal: true,
                ModalShow: false,
                modalContent: "",
                selectedLangId: selected[0].id,
                selectedLangIndex: 0,
                currentLang: selected[0].tag,
              },
              () => {
                if (selected[0].direction.toLowerCase() === "rtl") {
                  this.setState({ rtlClass: " rtlStyle" });
                } else {
                  this.setState({ rtlClass: " ltrStyle" });
                }
              }
            );
          } else if (result.status === 401) {
            LogoutFunction();
          }
        })
        .catch((err) => {
          console.log(err);
        });
    }
  }

  onLangItemClick(id) {
    let selectedLength = 0;
    this.state.langList.forEach((element) => {
      if (element.selected) selectedLength++;
    });

    let langs = JSON.parse(JSON.stringify(this.state.langList));
    let found = false;
    langs.forEach((element) => {
      if (element.id === id) {
        if (element.selected) {
          if (selectedLength < 2) return;
          element.selected = false;
          if (element.default) {
            element.default = false;
            found = true;
          }
        } else {
          element.selected = true;
          if (selectedLength === 0) element.default = true;
        }
      }
    });

    if (found) {
      let set = false;
      langs.forEach((element) => {
        if (element.selected && element.id !== id && !set) {
          element.default = true;
          set = true;
        }
      });
    }

    this.setState({ langList: langs });
  }

  onLangItemDefaultClick(id) {
    var langs = JSON.parse(JSON.stringify(this.state.langList));
    langs.forEach((element) => {
      if (element.id === id) {
        if (!element.default) element.default = true;
      }
    });

    langs.forEach((element) => {
      if (element.id !== id && element.default) element.default = false;
    });

    this.setState({ langList: langs });
  }

  showLangdialog() {
    this.setState(
      { ModalShow: true, modalContent: "language", lockModal: true },
      () => {
        let langs = JSON.parse(JSON.stringify(this.state.langList));
        langs.forEach((element) => {
          element.selected = false;
          element.default = false;
        });

        langs.forEach((element) => {
          this.state.userLangList.forEach((element1) => {
            if (element.id === element1.id) {
              element.selected = element1.selected;
              element.default = element1.default;
            }
          });
        });

        this.setState({ langList: langs });
      }
    );
  }

  render() {
    if (!this.state.pageLoading) {
      return (
        <div className="Login">
          <div className="header">
            <div
              onClick={this.onBack.bind(this)}
              className="linkStyle backButton"
            >
              <img
                src={Back}
                alt=""
                className="backButtonIcon"
                style={{ transform: "rotate(180deg)" }}
              />
              بازگشت
            </div>
            <div
              style={{
                display: "flex",
                flexDirection: "row",
                height: "fit-content",
                alignItems: "center",
              }}
            >
              <Tooltip title="اطلاعات کاربری">
                <div
                  onClick={this.onProfile.bind(this)}
                  className="linkStyle backButton"
                  // data-tip="اطلاعات کاربری"
                  // data-place="right"
                >
                  <img src={Profilee} alt="" className="backButtonIcon" />
                </div>
              </Tooltip>
              <div
                style={{
                  height: "20px",
                  minWidth: "1px",
                  backgroundColor: "var(--brown1)",
                  margin: "0px 5px",
                }}
              />
              <Tooltip title="خروج">
                <div
                  onClick={this.onLogout.bind(this)}
                  className="linkStyle backButton"
                  // data-tip="خروج"
                  // data-place="bottom"
                >
                  <img src={Logout} alt="" className="backButtonIcon" />
                </div>
              </Tooltip>
            </div>
          </div>
          <div className="LoginContent">
            {!this.props.isEdit && (
              <div className="RestaurantsListTitle">ایجاد رستوران جدید</div>
            )}
            {this.props.isEdit && (
              <div className="RestaurantsListTitle">ویرایش رستوران</div>
            )}
            <div className="RestaurantsListSubTitle">{this.state.subTitle}</div>
            {/* {this.props.isEdit && <div className="RestaurantsListSubTitle">{this.props.match.params.id}</div>} */}
            <div className="restaurantsListContainer">
              <div
                style={{
                  width: "100%",
                  display: "flex",
                  flexDirection: "row",
                  justifyContent: "space-between",
                }}
              >
                <div
                  style={{
                    display: "flex",
                    flexDirection: "column",
                    justifyContent: "center",
                    alignItems: "center",
                  }}
                >
                  <div
                    className="newPicContainer"
                    onClick={this.importLogo.bind(this)}
                  >
                    <img
                      src={this.state.logoUrl}
                      alt=""
                      style={{
                        width: "105%",
                        height: "105%",
                        objectFit: "cover",
                      }}
                    />
                    <div className="newPicIcon">
                      {!this.state.uploadButtonDisable && (
                        <img
                          src={NewPic}
                          style={{ width: "50%", height: "50%" }}
                          alt=""
                        />
                      )}
                      {this.state.uploadButtonDisable && (
                        <ClapSpinner
                          frontColor="var(--brown1)"
                          backColor="var(--brown1)"
                        />
                      )}
                    </div>
                  </div>
                  <div className="newPicTitle">بارگذاری لوگو</div>
                  <div className="newPicSubTitle">150 × 150</div>
                </div>

                <div
                  style={{
                    display: "flex",
                    flexDirection: "column",
                    justifyContent: "center",
                    alignItems: "center",
                  }}
                >
                  <div
                    className="newPicContainer"
                    onClick={this.importHeader.bind(this)}
                  >
                    <img
                      src={this.state.headerUrl}
                      alt=""
                      style={{
                        width: "105%",
                        height: "105%",
                        objectFit: "cover",
                      }}
                    />
                    <div className="newPicIcon">
                      {!this.state.uploadButtonDisableHeader && (
                        <img
                          src={NewPic}
                          style={{ width: "50%", height: "50%" }}
                          alt=""
                        />
                      )}
                      {this.state.uploadButtonDisableHeader && (
                        <ClapSpinner
                          frontColor="var(--brown1)"
                          backColor="var(--brown1)"
                        />
                      )}
                    </div>
                  </div>
                  <div className="newPicTitle">بارگذاری بنر</div>
                  <div className="newPicSubTitle">1920 × 300</div>
                </div>
              </div>

              <input
                type="file"
                ref={this.inputFile}
                onChange={this.uploadLogo}
                accept="image/png,.jpg"
                style={{ display: "none" }}
                disabled={this.state.uploadButtonDisable}
              />

              <input
                type="file"
                ref={this.inputFileHeader}
                onChange={this.uploadHeader}
                accept="image/png,.jpg"
                style={{ display: "none" }}
                disabled={this.state.uploadButtonDisableHeader}
              />

              <div
                className="selectLangButtonContainer"
                onClick={this.showLangdialog.bind(this)}
              >
                <div className="selectLangButtonTitle">
                  زبان های دلخواه خود را انتخاب کنید
                </div>
                <div className="selectLangButtonInfo">
                  {this.state.userLangList.length} زبان
                </div>
              </div>

              <div className="langTabsContainer">
                <div className="langTabsContainerLine" />
                {this.state.userLangList.map((item) => {
                  return (
                    <LangButton
                      key={item.id}
                      id={item.id}
                      title={item.title}
                      default={item.default}
                      selected={
                        this.state.selectedLangId === item.id ? true : false
                      }
                      onClick={this.selectLangClick.bind(this)}
                    />
                  );
                })}
              </div>

              <Form.Control
                // maxLength="11"
                className={
                  this.state.resNameErrorText !== ""
                    ? "inputStyleForm inputError" + this.state.rtlClass
                    : "inputStyleForm" + this.state.rtlClass
                }
                placeholder={word[this.state.currentLang]["resName"]}
                type="text"
                name="resNameValue"
                // value={this.state.resNameValue}
                onChange={(e) => {
                  let userlangs = JSON.parse(
                    JSON.stringify(this.state.userLangList)
                  );
                  userlangs[this.state.selectedLangIndex].name = e.target.value;
                  this.setState({ userLangList: userlangs });
                }}
                value={
                  this.state.userLangList.length > 0 &&
                  this.state.userLangList[this.state.selectedLangIndex].name !==
                    undefined &&
                  this.state.userLangList[this.state.selectedLangIndex].name !==
                    null
                    ? this.state.userLangList[this.state.selectedLangIndex].name
                    : ""
                }
                disabled={this.state.buttonDisabled}
              />
              <div
                className="errorMessageContainer"
                style={{ marginBottom: "2px", padding: "0px 10px" }}
              >
                {this.state.resNameErrorText}
              </div>

              <Form.Control
                className={"inputStyleForm" + this.state.rtlClass}
                placeholder={word[this.state.currentLang]["resAddress"]}
                type="text"
                name="addressValue"
                onChange={(e) => {
                  let userlangs = JSON.parse(
                    JSON.stringify(this.state.userLangList)
                  );
                  userlangs[this.state.selectedLangIndex].address =
                    e.target.value;
                  this.setState({ userLangList: userlangs });
                }}
                value={
                  this.state.userLangList.length > 0 &&
                  this.state.userLangList[this.state.selectedLangIndex]
                    .address !== undefined &&
                  this.state.userLangList[this.state.selectedLangIndex]
                    .address !== null
                    ? this.state.userLangList[this.state.selectedLangIndex]
                        .address
                    : ""
                }
                disabled={this.state.buttonDisabled}
              />
              <div
                className="errorMessageContainer"
                style={{ marginBottom: "2px" }}
              >
                {this.state.addressErrorText}
              </div>
              {/* <Form.Control
                                className={"inputStyleForm"+this.state.rtlClass}
                                placeholder={word[this.state.currentLang]['priceUnit']}
                                type="text"
                                name="priceUnitValue"
                                onChange={(e)=>{
                                    let userlangs= JSON.parse(JSON.stringify(this.state.userLangList));
                                    userlangs[this.state.selectedLangIndex].priceUnit=e.target.value;
                                    this.setState({userLangList:userlangs});
                                }}
                                value={this.state.userLangList.length>0 && this.state.userLangList[this.state.selectedLangIndex].priceUnit!==undefined && this.state.userLangList[this.state.selectedLangIndex].priceUnit!==null ? this.state.userLangList[this.state.selectedLangIndex].priceUnit:''}
                                disabled={this.state.buttonDisabled}
                            /> */}

              <Form.Control
                as="textarea"
                className={"inputStyleForm" + this.state.rtlClass}
                style={{ minHeight: "60px" }}
                placeholder={word[this.state.currentLang]["description"]}
                type="text"
                name="descriptionValue"
                // onChange={this.textHandleChange}
                // value={this.state.descriptionValue}
                onChange={(e) => {
                  let userlangs = JSON.parse(
                    JSON.stringify(this.state.userLangList)
                  );
                  userlangs[this.state.selectedLangIndex].descr =
                    e.target.value;
                  this.setState({ userLangList: userlangs });
                }}
                value={
                  this.state.userLangList.length > 0 &&
                  this.state.userLangList[this.state.selectedLangIndex]
                    .descr !== undefined &&
                  this.state.userLangList[this.state.selectedLangIndex]
                    .descr !== null
                    ? this.state.userLangList[this.state.selectedLangIndex]
                        .descr
                    : ""
                }
                disabled={this.state.buttonDisabled}
                // onKeyPress={this.handleKeyPress.bind(this)}
                // ref={this.textInput}
              />
              <div
                className="errorMessageContainer"
                style={{ marginBottom: "2px" }}
              >
                {this.state.descriptionErrorText}
              </div>

              <Form.Control
                disabled={this.state.buttonDisabled}
                value={this.state.priceUnitValue}
                className="inputStyleForm forceFont"
                placeholder="واحد پولی را انتخاب کنید"
                onChange={this.priceUnitHandleChange.bind(this)}
                as="select"
              >
                <option
                  disabled
                  style={{ color: "var(--placeholder)" }}
                  className="forceFont"
                >
                  واحد پولی را انتخاب کنید
                </option>
                {this.state.priceUnitList.map((item, i) => {
                  return (
                    <option key={i} id={item.id} className="forceFont">
                      {item.rtlTitle !== item.ltrTitle
                        ? item.rtlTitle + "(" + item.ltrTitle + ")"
                        : item.rtlTitle}
                    </option>
                  );
                })}
              </Form.Control>
              <div
                className="errorMessageContainer"
                style={{ marginBottom: "2px" }}
              >
                {this.state.priceUnitErrorText}
              </div>

              <Form.Control
                disabled={this.state.buttonDisabled}
                value={this.state.businessTypeValue}
                className="inputStyleForm forceFont"
                placeholder="نوع برند را مشخص کنید"
                onChange={this.businessTypeHandleChange.bind(this)}
                as="select"
              >
                <option
                  disabled
                  style={{ color: "var(--placeholder)" }}
                  className="forceFont"
                >
                  نوع برند را مشخص کنید
                </option>
                {this.state.businessType.map((item, i) => {
                  return (
                    <option key={i} id={item.id} className="forceFont">
                      {item.title}
                    </option>
                  );
                })}
              </Form.Control>
              <div
                className="errorMessageContainer"
                style={{ marginBottom: "2px" }}
              >
                {this.state.resTypeErrorText}
              </div>

              <Form.Control
                // maxLength="11"
                className="inputStyleForm"
                style={{ direction: "ltr" }}
                placeholder="تلفن"
                type="tel"
                name="phoneNumValue"
                onChange={this.textHandleChange}
                value={this.state.phoneNumValue}
                disabled={this.state.buttonDisabled}
                // onKeyPress={this.handleKeyPress.bind(this)}
                // ref={this.textInput}
              />
              <div
                className="errorMessageContainer"
                style={{ marginBottom: "2px" }}
              >
                {this.state.phoneNumErrorText}
              </div>

              <Form.Control
                // maxLength="11"
                className={
                  this.state.emailErrorText !== ""
                    ? "inputStyleForm inputError"
                    : "inputStyleForm"
                }
                style={{ direction: "ltr" }}
                placeholder="پست الکترونیک"
                type="text"
                name="emailValue"
                onChange={this.textHandleChange}
                value={this.state.emailValue}
                disabled={this.state.buttonDisabled}
                // onKeyPress={this.handleKeyPress.bind(this)}
                // ref={this.textInput}
              />
              <div
                className="errorMessageContainer"
                style={{ marginBottom: "2px" }}
              >
                {this.state.emailErrorText}
              </div>

              <div
                style={{
                  width: "100%",
                  display: "flex",
                  flexDirection: "row",
                  justifyContent: "space-between",
                  marginTop: "5px",
                  marginBottom: "40px",
                  alignItems: "center",
                }}
              >
                <div style={{ width: "32%" }}>
                  <CustomButton
                    disabled={this.state.buttonDisabled}
                    title="انصراف"
                    img={Cancel}
                    backColor="var(--black1)"
                    onClick={this.cancelClick.bind(this)}
                  />
                </div>
                <div style={{ width: "32%" }}>
                  <CustomButton
                    disabled={this.state.buttonDisabled}
                    loading={this.state.doneLoading}
                    title="ذخیره"
                    img={Tick}
                    onClick={this.doneClick.bind(this)}
                  />
                </div>
                <div style={{ width: "32%" }}>
                  <CustomButton
                    disabled={this.state.buttonDisabled}
                    loading={this.state.menuLoading}
                    title="منو"
                    img={Next}
                    imgRotate={180}
                    onClick={this.menuClick.bind(this)}
                  />
                </div>
              </div>
            </div>
          </div>

          <Modal
            show={this.state.ModalShow}
            animation={false}
            onHide={this.hideModal.bind(this)}
            backdrop={this.state.lockModal}
            centered
          >
            {this.state.modalContent === "profile" && (
              <Profile hideModal={this.hideModal.bind(this)} />
            )}
            {this.state.modalContent === "language" && (
              <div className="profileContainer">
                <div
                  style={{
                    width: "100%",
                    display: "flex",
                    flexDirection: "column",
                    justifyContent: "flex-start",
                    alignItems: "center",
                  }}
                >
                  <div
                    className="fiObjectTitle"
                    style={{ marginBottom: "10px" }}
                  >
                    انتخاب زبان
                  </div>
                  <div
                    className="fiObjectSubTitle"
                    style={{ marginBottom: "20px" }}
                  >
                    زبان های مورد نظر برای نمایش اطلاعات و منو برای کاربر را
                    انتخاب کنید
                  </div>
                  <div className="langList">
                    {this.state.langList.map((item, i) => {
                      return (
                        <LangItem
                          key={i}
                          title={item.title}
                          id={item.id}
                          selected={item.selected}
                          default={item.default}
                          onLangItemClick={this.onLangItemClick.bind(this)}
                          onLangItemDefaultClick={this.onLangItemDefaultClick.bind(
                            this
                          )}
                        />
                      );
                    })}
                  </div>
                </div>

                <div
                  style={{
                    width: "100%",
                    display: "flex",
                    flexDirection: "row",
                    justifyContent: "space-between",
                    marginTop: "0px",
                    alignItems: "center",
                  }}
                >
                  {this.state.lockModal !== "static" && (
                    <div style={{ flex: "1" }}>
                      <CustomButton
                        title="انصراف"
                        imgHeight={19}
                        backColor="var(--black1)"
                        imgWidth={25}
                        minHeight="35px"
                        img={Cancel}
                        onClick={this.hideModal.bind(this)}
                      />
                    </div>
                  )}
                  {this.state.lockModal !== "static" && (
                    <div style={{ minWidth: "5px" }} />
                  )}
                  <div style={{ flex: "1" }}>
                    <CustomButton
                      title="ذخیره"
                      loading={this.state.saveLoading}
                      imgHeight={20}
                      imgWidth={25}
                      minHeight="35px"
                      img={Tick}
                      onClick={this.saveLanguage.bind(this)}
                    />
                  </div>
                </div>
              </div>
            )}
          </Modal>
        </div>
      );
    } else {
      return <Loading />;
    }
  }
}
